// extracted by mini-css-extract-plugin
module.exports = {"checkboxLabel":"ContactFormCheckbox_checkboxLabel__3lMR_","checkboxInput":"ContactFormCheckbox_checkboxInput__kqsSW"};